import { Component, OnInit, inject } from '@angular/core';
import { MatDialogRef, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import {TreeItemNode} from 'src/app/model/tree/tree-item-node.model';
import {TreeDataService} from 'src/app/services/tree-data.service';
import {isNotNullOrUndefined} from '../../utils.static';
import {Destroyed} from '../../directives/destroyed.directive';
import {take, takeUntil} from 'rxjs/operators';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { NgFor } from '@angular/common';

@Component({
    selector: 'app-dialog-select-center',
    templateUrl: './dialog-select-center.component.html',
    styleUrls: ['./dialog-select-center.component.scss'],
    imports: [MatDialogContent, NgFor, MatCheckboxModule, MatDialogActions, MatButtonModule]
})
export class DialogSelectCenterComponent extends Destroyed implements OnInit {
    private readonly treeDataService = inject(TreeDataService);
    dialogRef = inject<MatDialogRef<DialogSelectCenterComponent>>(MatDialogRef);


    listOfPlace: TreeItemNode[];
    listExclude: TreeItemNode[];
    selectedPlace: TreeItemNode;
    other = false;

    constructor() {
        super();
        this.treeDataService.allPlacesMessager.pipe(takeUntil(this.destroyed), take(1))
            .subscribe(data => {
                this.listOfPlace = [];
                this.getChildPlaces(data);
            });
    }

    ngOnInit() {
        if (this.other) {
            this.treeDataService.allExcludePlacesOtherMessager
                .pipe(takeUntil(this.destroyed))
                .subscribe(listOfExclude => {
                    if (listOfExclude && listOfExclude.length > 0 && this.listOfPlace && this.listOfPlace.length > 0) {
                        this.listExclude = listOfExclude;
                    }
                });
        } else {
            this.treeDataService.allExcludePlacesMessager
                .pipe(takeUntil(this.destroyed))
                .subscribe(listOfExclude => {
                    if (listOfExclude && listOfExclude.length > 0 && this.listOfPlace && this.listOfPlace.length > 0) {
                        this.listExclude = listOfExclude;
                    }
                });
        }
    }

    getChildPlaces(placeList: TreeItemNode[]) {
        placeList.forEach(place => {
            if (!(place.listOfChilds && place.listOfChilds.length > 0)) {
                this.listOfPlace.push(place);
            }
            if (isNotNullOrUndefined(place.listOfChilds)) {
                this.getChildPlaces(place.listOfChilds);
            }
        });
    }

    selectPlace(place: TreeItemNode) {
        if (this.selectedPlace === place) {
            this.selectedPlace = null;
        } else {
            this.selectedPlace = place;
        }
    }

    checkPlace(place: TreeItemNode) {
        return place === this.selectedPlace;
    }

    canShow(): TreeItemNode[] {
        return this.listOfPlace.filter(
            item => !this.listExclude || (this.listExclude && !this.listExclude.find(exclude => item.id === exclude.id)));
    }

    onNoClick(): void {
        this.dialogRef.close();
    }

    onValidation() {
        this.dialogRef.close(this.selectedPlace);
    }

}
